import DesktopNavigationItem from '@/abs-core/shared/components/core/DesktopNavigationItem.vue'
import { SidebarMenuD, SidebarMenuItemD } from './index.d'
import { labelContent } from '@/addons/functions'
import { data as menuItems } from './menuData.json'
import { Routes } from '@/router'
import { isConfigTruthy } from '@/addons/functions/configs'

export interface State {
  sidebarMenu: SidebarMenuD
}

const formatMenuItem = (item): SidebarMenuItemD => {
  const { qs, label, link, submenu } = item.attributes

  // Icons for the first menu level
  const firstLevelIcons = {
    'POS:::dashbord_stock': 'warehouse',
    'POS:::dashboard_frontoffice': 'front-office',
    'POS:::dashboard_backoffice': 'back-office',
  }
  const icon = firstLevelIcons[item.id]
  const menuitem: SidebarMenuItemD = {
    component: DesktopNavigationItem,
    props: {
      label: labelContent(label),
      sections: submenu.map((el: any) => formatMenuItem(el)),
      icon,
      link: !icon && link.replace('.', '/'),
    },
  }
  if (qs) {
    menuitem.props.qs = qs
  }

  return menuitem
}

export const initState = (): State => {
  const topItems = [
    {
      component: DesktopNavigationItem,
      props: { icon: 'home', label: 'Home', link: Routes.DASHBOARD },
    },
    ...menuItems.map((mi) => formatMenuItem(mi)), // TODO: take items from DB
  ]

  topItems.push({
    component: DesktopNavigationItem,
    props: {
      icon: 'catalogo_on',
      label: 'mmfg_menu.catalog',
      link: Routes.CATALOG,
      condition: () => isConfigTruthy('ENDLESSAISLE_ENABLED'),
    },
  })

  const menu = {
    sidebarMenu: {
      top: topItems,
      center: [],
      bottom: [],
      optional: [],
    },
  }

  return menu
}
